export const SITE_LOGO = '/images/logo_btbp.png';

/** 生产站默认 Origin；可用 VITE_SITE_ORIGIN 覆盖 */
export const SITE_ORIGIN = (
  import.meta.env.VITE_SITE_ORIGIN || 'https://www.btbpbpo.com'
).replace(/\/$/, '');

export const SITE_NAME = 'BTBP';

/** 默认社交分享图（绝对 URL） */
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/banner.jpg`;

export function isNoIndexSite(): boolean {
  return import.meta.env.VITE_NOINDEX === 'true';
}

/** 规范路径：首页 `/`，其余统一无尾斜杠 */
export function canonicalPath(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  const cleaned = pathname.replace(/\/+$/, '');
  return cleaned || '/';
}

export function absoluteUrl(pathname: string): string {
  const path = canonicalPath(pathname);
  return path === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;
}
